/* eslint eqeqeq: "off" */
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  UserOutlined,
  FieldTimeOutlined,
  SearchOutlined,
  HomeOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  CustomerServiceOutlined,
  AuditOutlined,
  LogoutOutlined,
  LoginOutlined,
  UserAddOutlined,
  CommentOutlined,
  CloseOutlined,
  UpCircleFilled,
  LoadingOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { useHistory, withRouter } from "react-router-dom";
import {
  Layout,
  Popover,
  Image,
  Input,
  Col,
  Row,
  Modal,
  Typography,
  FloatButton,
  Tooltip,
  Spin,
  // Avatar,
} from "antd";
import { Link } from "react-router-dom";
import Logo1 from "../../assets/images/PMT-LOGO.png";
// import Logo1 from "../../assets/images/logo-dark.png";
// import sectionFooter from "../../assets/images/new-footer-img.png";
// import sectionFooter from "../../assets/images/footer-output.png";
// import sectionFooter from "../../assets/images/footer-output.png";
// import sectionFooter from "../../assets/images/footer-new-img-1.png";
// import GooglePlay from "../../assets/images/google play and app store.png";
// import Appstore from "../../assets/images/app store-1.png";
import Qrcode from "../../assets/images/qr-code.png";
import { FaAngleDown } from "react-icons/fa6";
import { FaQuestionCircle } from "react-icons/fa";
import "./index.css";
import Spinner from "../spinner/Spinner";
// import { isEmpty } from "lodash";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import { FaKey, FaLocationDot, FaMobile } from "react-icons/fa6";
import {
  PiPackageBold,
  PiCar,
  PiCity,
  // PiPackageThin,
  // PiBuildingOffice,
} from "react-icons/pi";
import { FiActivity } from "react-icons/fi";
import { ToastContainer } from "react-toastify";
import { toast, Toaster } from "react-hot-toast";
import useMedia from "use-media-antd-query";
import { footerList, travelModeLinks } from "./data";
import {
  loadDestinationList,
  loadPackageCategoryList,
} from "../../store/dashboard/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  loadDestinationSearchList,
  loadPackagesList,
} from "../../store/packages/actions";
import moment from "moment";
import { phoneIsValid } from "../../helpers/validations";
import api, { setAuthToken } from "../../helpers";
import { jwtDecode } from "jwt-decode";
import { debounce, isEmpty } from "lodash";
import { myAccountApi } from "../../store/My-Account/actions";
import {
  Category,
  // SchoolOutlined,
  // TravelExploreOutlined,
} from "@mui/icons-material";
// import { FaUniversity } from "react-icons/fa";

const { Header, Content } = Layout;
// const { Header, Content, Footer } = Layout;

const LayoutMain = (props) => {
  const media = useMedia();
  const history = useHistory();
  const dispatch = useDispatch();
  // const [selectedMenu, setSelectedMenu] = useState("");
  const [selectedMenuRoute, setSelectedMenuRoute] = useState("");
  const [footerTabs, setFooterTabs] = useState("Our Offerings");

  //Login initial states and modal api's
  const [loginModal, setLoginModal] = useState(false);
  const [loginBtnDisabled, setLoginBtnDisabled] = useState(false);
  const [loginValidations, setLoginValidations] = useState(false);
  const [customerMobileValidations, setCustomerMobileValidations] =
    useState(false);
  const [customerMobile, setCustomerMobile] = useState("");
  const [password, setPassword] = useState("");

  //mobile and mail validations
  const validationEnquireChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-enquire-input");
    const current_value = inputValue.replace(/ /g, "");
    setCustomerMobile(current_value);

    if (!phoneIsValid(current_value)) {
      document.getElementById("error-enquire-panel").style.display = "block";
      mainInput.value = current_value;
      setCustomerMobileValidations(true);
    } else {
      document.getElementById("error-enquire-panel").style.display = "none";
      if (phoneIsValid(current_value)) {
        const phoneNumberArr = [...current_value.matchAll(/\d{2}/g)].map(
          (x) => x["0"]
        );
        mainInput.value = phoneNumberArr.join(" ");
        // setuserValue(true);
      }
      setCustomerMobileValidations(false);
    }
  };

  //logged user details
  const loggedUser = localStorage.getItem("loggedInUser");
  const verifiedUserDetails = loggedUser ? JSON.parse(loggedUser) : "";
  const verifiedUserData =
    verifiedUserDetails &&
    verifiedUserDetails.data &&
    verifiedUserDetails.data.token !== undefined
      ? jwtDecode(verifiedUserDetails.data.token)
      : "";
  const userNameAvatar = !isEmpty(verifiedUserData)
    ? verifiedUserData.firstName.slice(0, 1)
    : "";

  const loginDetailsApi = () => {
    if (customerMobile !== "" && password !== "") {
      setLoginValidations(false);
      setLoginBtnDisabled(true);
      setTimeout(() => {
        setLoginBtnDisabled(false);
      }, 3000);
      api
        .post("/user/login", {
          emailOrMobile: customerMobile,
          loginPassword: password,
        })
        .then((res) => {
          toast.success(res.data.msg);
          setAuthToken(res.data.data.token);
          localStorage.setItem("loggedInUser", JSON.stringify(res.data));
          setLoginModal(false);
          setTimeout(() => {
            history.push("/my-account");
            dispatch(myAccountApi());
          }, 2000);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          toast.error(errorMsg || "There is an issue while verify the otp");
          Promise.reject(error);
        });
    } else {
      setLoginValidations(true);
      setLoginModal(true);
    }
  };

  ///Login initial states end
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const firstRoute =
    props && props.location !== undefined && props.location.pathname
      ? props.location.pathname
      : "";
  const pageRoutes = firstRoute && firstRoute.split("/")[1]; // returns "packages"
  const pageRoute = pageRoutes ? "/" + pageRoutes : firstRoute;
  useEffect(() => {
    if (pageRoute !== "") {
      setSelectedMenuRoute(pageRoute);
    }
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [hideTop, setHideTop] = useState(false);
  const [scrollTop, setScrollTop] = useState(false);
  useEffect(() => {
    if (window.scrollY > 500) {
      setScrollTop(true);
    } else {
      setScrollTop(false);
    }
    const handleScroll = () => {
      if (window.scrollY > 50) {
        // Adjust the scroll threshold as needed
        setHideTop(true);
      } else {
        setHideTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setScrollTop(true);
      } else {
        setScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  //store integrations

  useEffect(() => {
    dispatch(loadDestinationList());
    dispatch(loadPackageCategoryList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { destination_list = [], package_category_list = [] } = useSelector(
    (state) => state.Dashboard
  );
  const { destination_search_list = [] } = useSelector(
    (state) => state.Packages
  );

  const destinationOptions =
    destination_list &&
    destination_list.queryResult &&
    destination_list.queryResult.length > 0
      ? destination_list.queryResult.map((data) => {
          const imageUrl =
            data.images && data.images.length > 0
              ? data.images[0].imageUrl
              : "";
          return {
            destinationName: data.destinationName,
            images: data.images && imageUrl !== "" ? imageUrl : "",
            _id: data._id,
          };
        })
      : [];

  const packageCategoryList =
    package_category_list &&
    package_category_list.queryResult &&
    package_category_list.queryResult.length > 0
      ? package_category_list.queryResult.map((data) => {
          return {
            packageCategoryName: data.packageCategoryName,
            description: data.description !== "" ? data.description : "",
            _id: data._id,
          };
        })
      : [];

  const selectedPackageRoutes =
    selectedMenuRoute == "/packages" ||
    selectedMenuRoute == "/package-details" ||
    pageRoute == "/packages" ||
    pageRoute == "/package-details";
  //package routes
  const selectedPackageMenu =
    props &&
    props.location &&
    props.location.state &&
    props.location.state.packageCategoryName;

  const packageRoutes = (
    <div
      class={
        !selectedPackageRoutes
          ? "packageMenu drhvr pt-2 pr-1 pl-1 pb-2"
          : "selected-packageMenu drhvr pt-2 pr-1 pl-1 pb-2"
      }
    >
      {packageCategoryList && packageCategoryList.length > 0
        ? packageCategoryList.map((data) => {
            return (
              <Link
                className={
                  selectedPackageMenu === data.packageCategoryName
                    ? "_drpdubro w-[105%] ml-[-3px] mt-1 pr-4 pl-4 pt-2 pb-2 rounded-md bg-[#e74c3c] text-[white] log cursor-pointer"
                    : "_drpdubro w-[105%] ml-[-3px] mt-1 pr-4 pl-4 pt-2 pb-2 rounded-md hover:bg-[#e74c3c] hover:text-[white] log cursor-pointer"
                }
                to={{
                  pathname: `/packages/${data.packageCategoryName}`,
                  state: data,
                }}
                // onClick={() => {
                //   history.push({
                //     pathname: `/packages/${data.packageCategoryName}`,
                //     state: data,
                //   });
                // }}
              >
                <div className="hover:text-[white] menuropos">
                  <PiPackageBold fontSize="medium" className="" />
                </div>
                <p class="_romnutxt hover:text-[white]" id="shwlogn">
                  <p class="submenu-text">
                    {data.packageCategoryName !== undefined
                      ? data.packageCategoryName + " Packages"
                      : ""}
                  </p>
                </p>
              </Link>
            );
          })
        : "No Menu found"}
    </div>
  );

  const selectedMenuStyles = {
    background: "#d390901c",
    zIndex: 10,
    padding: "4px 8px",
    height: "51px",
    display: "inline-block",
    width: "max-content",
    borderRadius: "9px",
    marginTop: selectedPackageRoutes && media == "xs" ? "-25px" : "-23px",
  };
  const selectedPackageMenuStyles = {
    background: "#d390901c",
    zIndex: 10,
    padding: "4px 8px",
    height: "51px",
    display: "flex",
    width: "max-content",
    borderRadius: "9px",
    marginTop: selectedPackageRoutes && media == "xs" ? "-25px" : "-23px",
  };
  const items = [
    {
      key: "home",
      label: (
        <Link
          to={{
            pathname: "/",
          }}
          className={
            selectedMenuRoute == "/" || pageRoute == "/"
              ? "w-[100%] flex flex-col text-[#db2528] hover:text-[#db2528] hover:scale-95"
              : "w-[100%] flex flex-col hover:text-[#db2528] hover:scale-95"
          }
        >
          <HomeOutlined
            className={
              selectedMenuRoute == "/" || pageRoute == "/"
                ? "pl-[14px] pt-1 text-[21px] xl:text-[20px] mt-[48px] text-center"
                : media === "xs"
                ? "pl-[14px] pt-1 text-[16px] mt-[50px] text-center"
                : "menu-hover-items"
            }
          />{" "}
          <p
            style={
              selectedMenuRoute == "/" || pageRoute == "/"
                ? selectedMenuStyles
                : {}
            }
            className={
              media === "xs"
                ? "menu-hover-small-bg text-[11.5px]"
                : "menu-hover-bg text-[13px] xxl:text-[14px]"
            }
          >
            Home
          </p>
        </Link>
      ),
      path: "/",
      // icon: <HomeOutlined />,
    },
    // {
    //   key: "holidays",
    //   label: (
    //     <Link
    //       to={{
    //         pathname: "/holidays",
    //       }}
    //       className={
    //         selectedMenuRoute == "/holidays" || pageRoute == "/holidays"
    //           ? "flex flex-col text-[#db2528] hover:text-[#db2528] hover:scale-95"
    //           : "flex flex-col hover:text-[#db2528] hover:scale-95"
    //       }
    //     >
    //       <HolidayVillage
    //         className={
    //           selectedMenuRoute == "/holidays" || pageRoute == "/holidays"
    //             ? "pl-4 pt-1 text-[20px] mt-[48px] text-center"
    //             : media === "xs"
    //             ? "menu-hover-mobile-holiday-items ml-4"
    //             : "menu-hover-holiday-items ml-4"
    //         }
    //       />{" "}
    //       <p
    //         style={
    //           selectedMenuRoute == "/holidays" || pageRoute == "/holidays"
    //             ? selectedMenuStyles
    //             : {}
    //         }
    //         className="menu-hover-holidays-bg"
    //       >
    //         Holidays
    //       </p>
    //     </Link>
    //   ),
    //   path: "/holidays",
    // },
    {
      key: "packages",
      label: (
        <Link
          to={{
            pathname: "/packages",
          }}
        >
          <Popover
            trigger="hover"
            placement="bottom"
            // arrow={false}
            // showArrow={false}
            content={packageRoutes}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            className={
              selectedPackageRoutes
                ? "flex flex-col text-[#db2528] hover:text-[#db2528] hover:scale-95 ml-[-5px] mr-[-5px]"
                : "flex flex-col hover:text-[#db2528] hover:scale-95 ml-[-5px] mr-[-5px]"
            }
            overlayClassName="no-arrow-popover"
            // open={popoverOpen}
            // onOpenChange={handlePopoverChange}
          >
            <PiPackageBold
              className={
                selectedPackageRoutes && media == "xs"
                  ? "ml-5 pt-1 text-[22px] mt-[20px]"
                  : selectedPackageRoutes
                  ? "ml-5 pt-1 text-[24px] mt-[30px]"
                  : media == "xs"
                  ? "ml-2 text-[16px] menu-hover-package-mobile-items"
                  : media == "sm"
                  ? "ml-2 menu-hover-package-items"
                  : "ml-5 menu-hover-package-items"
              }
            />{" "}
            <div
              style={selectedPackageRoutes ? selectedPackageMenuStyles : {}}
              className="menu-hover-packages-bg"
            >
              <p
                className={
                  media === "xs"
                    ? "text-[11.5px]"
                    : "text-[13px] xxl:text-[14px]"
                }
              >
                Packages
              </p>
              <FaAngleDown
                className={
                  selectedPackageRoutes
                    ? "ml-[5px] xl:ml-[3px] mr-[-8px] xl:mr-[-8px] text-[14px] mt-[26px]"
                    : "ml-[5px] xl:ml-[3px] mr-[-8px] xl:mr-[-13px] text-[14px] mt-[26px]"
                }
              />
            </div>
          </Popover>
        </Link>
      ),
      path: "/packages" || "/package-details",
    },
    {
      key: "cabs",
      label: (
        <Link
          to={{
            pathname: "/cab-details",
          }}
          className={
            selectedMenuRoute == "/cab-details" || pageRoute == "/cab-details"
              ? "flex flex-col text-[#db2528] hover:text-[#db2528] hover:scale-95"
              : "flex flex-col hover:text-[#db2528] hover:scale-95"
          }
        >
          <PiCar
            className={
              selectedMenuRoute == "/cab-details" || pageRoute == "/cab-details"
                ? "ml-3 pt-1 text-[24px] mt-[30px]"
                : media == "xs"
                ? "ml-2 text-[16px] menu-hover-cabs-mobile-items"
                : media == "sm"
                ? "ml-2 menu-hover-cab-items mt-[33px]"
                : "ml-4 menu-hover-cab-items"
            }
          />{" "}
          <p
            style={
              selectedMenuRoute == "/cab-details" || pageRoute == "/cab-details"
                ? selectedMenuStyles
                : {}
            }
            className={
              media === "xs"
                ? "menu-hover-cabs-bg text-[11.5px]"
                : "menu-hover-cabs-bg text-[13px] xxl:text-[14px]"
            }
          >
            Cabs
          </p>
        </Link>
      ),
      path: "/cab-details",
      // icon: <PiCar />,
    },
    {
      key: "activities",
      label: (
        <Link
          to={{
            pathname: "/destinations",
          }}
          className={
            selectedMenuRoute == "/destinations" || pageRoute == "/destinations"
              ? "flex flex-col text-[#db2528] hover:text-[#db2528] ml-[-7px] mr-[-7px] hover:scale-95"
              : "flex flex-col hover:text-[#db2528] hover:scale-95 ml-[-7px] mr-[-7px]"
          }
        >
          <PiCity
            className={
              selectedMenuRoute == "/destinations" ||
              pageRoute == "/destinations"
                ? "ml-5 pt-1 text-[24px] mt-[30px]"
                : media == "xs"
                ? "ml-2 text-[16px] menu-hover-activities-items mt-[35px]"
                : media == "sm"
                ? "ml-2 menu-hover-activities-items mt-[33px]"
                : "ml-5 menu-hover-activities-items"
            }
          />{" "}
          <p
            style={
              selectedMenuRoute == "/destinations" ||
              pageRoute == "/destinations"
                ? selectedMenuStyles
                : {}
            }
            className={
              media === "xs"
                ? "menu-hover-activities-bg text-[11.5px]"
                : "menu-hover-activities-bg text-[13px] xxl:text-[14px]"
            }
          >
            {/* Activities */}
            Destinations
          </p>
        </Link>
      ),
      path: "/destinations",
      icon: <FiActivity />,
    },
    {
      key: "aboutUs",
      label: (
        <Link
          to={{
            pathname: "/about-us",
          }}
          className={
            selectedMenuRoute == "/about-us" || pageRoute == "/about-us"
              ? "flex flex-col text-[#db2528] hover:text-[#db2528] hover:scale-95"
              : "flex flex-col hover:text-[#db2528] hover:scale-95"
          }
        >
          <InfoCircleOutlined
            className={
              selectedMenuRoute == "/about-us" || pageRoute == "/about-us"
                ? "pl-6 pt-1 text-[18px] mt-[48px] text-center"
                : media === "xs"
                ? "menu-hover-mobile-holiday-items text-[16px] ml-6"
                : "menu-hover-holiday-items ml-6"
            }
          />{" "}
          <p
            style={
              selectedMenuRoute == "/about-us" || pageRoute == "/about-us"
                ? selectedMenuStyles
                : {}
            }
            className={
              media == "xs"
                ? "menu-hover-about-us-bg text-[11.5px]"
                : "menu-hover-about-us-bg text-[13px] xxl:text-[14px] mt-1"
            }
          >
            {media === "xs" ? "Aboutus" : "About us"}
          </p>
        </Link>
      ),
      path: "/about-us",
    },
    // {
    //   key: "careers",
    //   label: (
    //     <Link
    //       to={{
    //         pathname: "/careers",
    //       }}
    //       className={
    //         selectedMenuRoute == "/careers" || pageRoute == "/careers"
    //           ? "flex flex-col text-[#db2528] hover:text-[#db2528] hover:scale-95 ml-[-7px] mr-[-7px]"
    //           : "flex flex-col hover:text-[#db2528] hover:scale-95 ml-[-7px] mr-[-7px]"
    //       }
    //     >
    //       <AuditOutlined
    //         className={
    //           selectedMenuRoute == "/careers" || pageRoute == "/careers"
    //             ? "pl-4 pt-1 text-[18px] mt-[48px] text-center"
    //             : media === "xs"
    //             ? "menu-hover-mobile-holiday-items text-[16px] ml-4"
    //             : "menu-hover-holiday-items ml-4"
    //         }
    //       />{" "}
    //       <p
    //         style={
    //           selectedMenuRoute == "/careers" || pageRoute == "/careers"
    //             ? selectedMenuStyles
    //             : {}
    //         }
    //         className={
    //           media === "xs"
    //             ? "menu-hover-careers-bg text-[11.5px] mt-1"
    //             : "menu-hover-careers-bg text-[13px] xxl:text-[14px] mt-1"
    //         }
    //       >
    //         Careers
    //       </p>
    //     </Link>
    //   ),
    //   path: "/careers",
    // },
  ];

  // const loginPagePath = "/login";
  const [popoverOpen, setPopoverOpen] = useState(false);
  const popoverRef = useRef(null);

  const handlePopoverChange = (visible) => {
    setPopoverOpen(visible);
  };
  const profileDetails = (
    <div class="_dropdownromenu drhvr">
      {verifiedUserData && verifiedUserData.firstName !== undefined ? (
        ""
      ) : (
        <div
          class="hover:text-[#eb3e43] _drpdubro log cursor-pointer"
          onClick={() => {
            setLoginModal(true);
            setPopoverOpen(false);
          }}
        >
          <div className=" menuropos">
            <LoginOutlined className="mr-2" />
          </div>
          <p class="_romnutxt" id="shwlogn">
            <p class="fnt14">{"Login"}</p>
          </p>
        </div>
      )}
      {verifiedUserData && verifiedUserData.firstName !== undefined ? (
        <a class="_drpdubro log" href="/my-account">
          <div className="menuropos">
            <UserAddOutlined className="mr-2" />
          </div>
          <p class="_romnutxt" id="shwlogn">
            <p class="fnt14">Profile</p>
          </p>
        </a>
      ) : (
        ""
      )}
      {verifiedUserData && verifiedUserData.firstName !== undefined ? (
        <div
          class="hover:text-[#eb3e43] _drpdubro log cursor-pointer"
          // href={loginPagePath}
          onClick={() => {
            setDownloadLoading(true);
            setTimeout(() => {
              setDownloadLoading(false);
              if (
                verifiedUserData &&
                verifiedUserData.firstName !== undefined
              ) {
                toast.success("Logged out successfully");
                setPopoverOpen(false);
                setTimeout(() => {
                  history.push("/");
                }, 1000);
                dispatch(myAccountApi());
              }
            }, 2000);
            localStorage.setItem("loggedInUser", "");
            localStorage.setItem("loggedOut", true);
            localStorage.setItem("loggedOut", true);
            localStorage.setItem("bookingStatus", "");
          }}
        >
          <div className="menuropos">
            <LogoutOutlined className="mr-2" />
          </div>
          <p class="_romnutxt" id="shwlogn">
            <p class="fnt14">Logout</p>
          </p>
        </div>
      ) : (
        ""
      )}

      {/* <a
        class="_drpdubro"
        href={loginPagePath}
        onClick={() => {
          localStorage.setItem("sessionUser", "");
          localStorage.setItem("mobileNo", "");
          }}
          >
          <div className="menuropos">
          <LogoutOutlined className="mr-2" />
        </div>
        <p class="_romnutxt" id="shwlogn">
        <p class="fnt14">Logout</p>
        </p>
      </a> */}
    </div>
  );

  const [query, setQuery] = useState("");
  const [valueSelected, setValueSelected] = useState("");
  const [selectedDestination, setSelectedDestination] = useState("");
  const [destinationSelected, setDestinationSelected] = useState("");
  const [destinationLoading, setDestinationLoading] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [searchArrays, setSearchArrays] = useState([]);
  const [searchDestinationSelected, setSearchDestinationSelected] =
    useState(false);

  // const handleChange = (e) => {
  //   const userInput = e.target.value;
  //   const filtered = destinationOptions
  //     .filter((row) =>
  //       row.destinationName.toLowerCase().includes(e.target.value.toLowerCase())
  //     )
  //     .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates
  //   setQuery(userInput);
  //   setFilteredSuggestions(userInput ? filtered : []);
  // };

  const handleClick = (suggestion) => {
    setQuery(suggestion.destinationName);
    setValueSelected(suggestion.destinationName);
    setSelectedDestination(suggestion);
    setFilteredSuggestions([]);
  };
  const handleChange = debounce((e) => {
    const userInput = e.target.value.toLowerCase();

    // const filtered = destinationOptions
    //   .filter((row) => row.destinationName.toLowerCase().includes(userInput))
    //   .filter(
    //     (item, index, self) =>
    //       index ===
    //       self.findIndex((t) => t.destinationName === item.destinationName)
    //   );
    setSearchDestinationSelected(true);
    setDestinationLoading(true);
    setTimeout(() => {
      setDestinationLoading(false);
    }, 3000);
    if (userInput !== "") {
      api
        .get(`/package/top-search-drop-down-data?searchFilter=${userInput}`)
        .then((res) => {
          // setFilteredSuggestions(res.data.data)
          setSearchArrays(
            res.data && res.data.data && res.data.data.data
              ? res.data.data.data
              : []
          );
          console.log(res.data, "response from search");
          return res.data;
        })
        .catch((error) => Promise.reject(error));
    } else {
      setSearchArrays([]);
      setSearchDestinationSelected(false);
    }
    // dispatch(loadDestinationSearchList(`?searchFilter=${userInput}`));

    setQuery(e.target.value);
    // setFilteredSuggestions([]);
    // setFilteredSuggestions(userInput ? filtered : []);
  }, 300);

  const destinationSearchRef = useRef(null);
  // Close dropdown when clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        destinationSearchRef.current &&
        !destinationSearchRef.current.contains(event.target)
      ) {
        setSearchDestinationSelected(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // let isDragging = false;
  // let startY, scrollTop;

  // useEffect(() => {
  //   const container = document.querySelector(".scroll-container");

  //   container.addEventListener("mousedown", (e) => {
  //     isDragging = true;
  //     startY = e.pageY;
  //     scrollTop = window.scrollY;
  //     container.style.cursor = "grabbing";
  //   });

  //   container.addEventListener("mousemove", (e) => {
  //     if (!isDragging) return;
  //     const walk = (e.pageY - startY) * 1.5; // Adjust scroll speed
  //     window.scrollTo(0, scrollTop - walk);
  //   });

  //   container.addEventListener("mouseup", () => {
  //     isDragging = false;
  //     container.style.cursor = "grab";
  //   });
  //   container.addEventListener("mouseleave", () => {
  //     isDragging = false;
  //     container.style.cursor = "grab";
  //   });
  // }, []);
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    setDownloadLoading(true);
    setTimeout(() => {
      setDownloadLoading(false);
    }, 3000);
    //eslint disable-next-line react-hooks/exhaustive-deps
  }, []);

  window.onload = function () {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setPopoverOpen(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  //chat modal

  const [chatModal, setChatModal] = useState(false);

  return (
    <React.Fragment>
      <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
        {downloadLoading == true || destinationSelected == true ? (
          <Spinner />
        ) : (
          ""
        )}
      </Col>
      <Layout
        style={{
          // padding: "6px",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
        id="scrollTop"
      >
        <Header
          className={
            media == "sm"
              ? `${hideTop ? "layout-top-tab-header" : "layout-tab-header"}`
              : media == "xs"
              ? `${
                  hideTop ? "layout-top-mobile-header" : "layout-mobile-header"
                }`
              : media == "md" &&
                windowDimensions.width > 845 &&
                windowDimensions.width < 900
              ? `${
                  hideTop
                    ? "layout-top-tab-header"
                    : "layout-medium-header-device-medium"
                }`
              : media == "md" &&
                windowDimensions.width > 800 &&
                windowDimensions.width < 845
              ? `${
                  hideTop
                    ? "layout-top-tab-header"
                    : "layout-medium-device-header"
                }`
              : media == "md"
              ? `${
                  hideTop ? "layout-top-medium-header" : "layout-medium-header"
                }`
              : media == "lg"
              ? `${
                  hideTop ? "layout-top-medium-header" : "layout-medium-header"
                }`
              : media == "xl"
              ? `${
                  hideTop
                    ? "large-top-extra-large-header"
                    : "large-extra-large-header"
                }`
              : windowDimensions.width > 1201 && windowDimensions.width <= 1385
              ? `${hideTop ? "layout-top-large-header" : "layout-large-header"}`
              : media == "xxl" &&
                windowDimensions.width > 1601 &&
                windowDimensions.width <= 1690
              ? `${hideTop ? "layout-top-header" : "layout-header"}`
              : media == "xxl" && windowDimensions.width > 1690
              ? `${hideTop ? "layout-top-header" : "layout-header"}`
              : `${hideTop ? "layout-top-header" : "layout-header"}`
          }
          style={{
            position: "fixed",
            top: "0px",
            // top: hideTop ? "-20px" : "0px",
            width: "100%",
            boxShadow:
              media == "sm" || media == "xs" ? "1px 0px 1px 1px lightgray" : "",
            // padding: "30px 0px",
          }}
        >
          {/* {media === "sm" || media === "xs" ? (
            <>
              <div className="flex justify-end mb-[-43px] pl-10">
                {" "}
                <div
                  className={
                    media === "xs" ? "ml-6 mr-0 mt-[-10px]" : "mr-8"
                  }
                >
                  <Popover
                    trigger={"hover"}
                    placement="bottom"
                    content={profileDetails}
                    className="rounded-md"
                  >
                    <div
                      className="cursor-pointer text-[white]"
                      // className="flex cursor-pointer hover:border-red-300 hover:border-b-2 h-[58px] text-[white]"
                      // className="flex cursor-pointer hover:border hover:border-red-300 hover:border-b-1 text-[white]"
                    >
                      <Button
                        type="text"
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#ffffff] hover:text-[#ffffff] border-none hover:bg-none hover:border-red-300 hover:border-b-2"
                      >
                        <UserOutlined className={""} />
                        <h1 className="">{media === "xs" ? "" : "Login"}</h1>
                      </Button>
                    </div>
                  </Popover>
                </div>
              </div>
            </>
          ) : ( */}
          <>
            <div
              className={
                hideTop
                  ? `top-header ${
                      hideTop
                        ? media === "xs"
                          ? "hide w-[112%]"
                          : media === "sm"
                          ? "hide w-[114%]"
                          : "hide"
                        : ""
                    }`
                  : `${
                      media === "xs" && hideTop === false
                        ? "w-[123%] top-header-small"
                        : media === "sm" && hideTop === false
                        ? "w-[117%] top-header-small"
                        : media === "md" &&
                          windowDimensions.width > 770 &&
                          windowDimensions.width < 900 &&
                          hideTop === false
                        ? "w-[117%] top-header-small"
                        : media === "md" && hideTop === false
                        ? "w-[117%] top-header-large"
                        : media === "lg" && hideTop === false
                        ? "w-[112%] top-header-large"
                        : "w-[108.4%] top-header-large"
                    }`
              }
            >
              <div
                className={`${
                  hideTop
                    ? media === "xs"
                      ? "mt-[-90px] flex flex-col pl-4 pr-4"
                      : media === "sm"
                      ? "mt-[-64px] flex flex-col pl-4 pr-4"
                      : "mt-[-102px]"
                    : media === "xs" || media === "sm"
                    ? "flex flex-col pl-4 pr-4"
                    : media === "md" &&
                      windowDimensions.width > 800 &&
                      windowDimensions.width < 900
                    ? "mt-[-11px] flex flex-col pl-4 pr-4"
                    : media === "md"
                    ? "mt-[-11px] flex justify-between pl-[65px] pr-[65px]"
                    : media === "lg"
                    ? "mt-[-11px] flex justify-between pl-[9%] pr-[9%]"
                    : media === "xl"
                    ? "mt-[-11px] flex justify-between pl-[6.5%] pr-[6.5%]"
                    : "mt-[-11px] flex justify-between pl-[11%] pr-[11%]"
                }`}
              >
                {/* Left Section */}
                <div
                  className={`left-section ${
                    media === "xs"
                      ? "flex flex-col justify-center mt-[-15px]"
                      : media === "sm"
                      ? "flex justify-center mt-[-15px]"
                      : windowDimensions.width > 750 &&
                        windowDimensions.width < 900
                      ? "flex justify-center mt-[10px]"
                      : "flex mt-[-4px] mb-2 pl-8"
                  }`}
                >
                  {/* <div
                    className={`info-item flex flex-row ${
                      media === "xs" ? "justify-center" : ""
                    }`}
                  >
                    <FaLocationDot className="icon mr-1 font-semibold" />
                    <h1
                      className="font-medium text-[11px]"
                      style={{ fontFamily: "Poppins" }}
                    >
                      11, VKK Menon Rd, Coimbatore
                    </h1>
                    {media !== "xs" && <h1 className="mx-3">|</h1>}
                  </div> */}
                  <div
                    className={`info-item flex flex-row ${
                      media === "xs" ? "justify-center mt-[-40px]" : ""
                    }`}
                  >
                    <FieldTimeOutlined className="icon mr-1 font-semibold" />
                    <h1
                      className="font-medium text-[11px]"
                      style={{ fontFamily: "Poppins" }}
                    >
                      Sun to Friday: 8.00 am to 7.00 pm
                    </h1>
                  </div>
                </div>

                {/* Right Section */}
                <div
                  className={`right-section flex ${
                    media === "xs" || media === "sm"
                      ? "justify-center mt-[-22px] pr-5"
                      : media === "md" &&
                        windowDimensions.width > 750 &&
                        windowDimensions.width < 900
                      ? "justify-center mt-[-22px] pr-5"
                      : "mt-[-5px] mb-2 pr-5"
                  }`}
                >
                  <div className="flex">
                    <div className="flex flex-row items-center">
                      <Link
                        to={"/faq"}
                        className="flex flex-row cursor-pointer text-[11px] font-medium hover:text-[#e74c3c] border-b-2 border-transparent px-1"
                        style={{ fontFamily: "Poppins" }}
                        // onClick={() => history.push("/faq")}
                      >
                        <FaQuestionCircle className="icon mr-1" /> FAQ
                      </Link>
                      <h1 className="mx-3 mt-[-4px]">|</h1>
                    </div>
                    <div className="flex flex-row items-center">
                      <Link
                        to={"/contact-us"}
                        className="flex flex-row cursor-pointer text-[11px] hover:text-[#e74c3c] border-b-2 border-transparent px-1"
                        style={{ fontFamily: "Poppins" }}
                        // onClick={() => history.push("/contact-us")}
                      >
                        <CustomerServiceOutlined className="icon mr-1" />{" "}
                        <p className="mt-[1px]">Contact us</p>
                      </Link>
                      <h1 className="mx-1 mt-[-4px]">|</h1>
                    </div>
                  </div>
                  {verifiedUserData &&
                  verifiedUserData.firstName !== undefined ? (
                    <Popover
                      trigger="hover"
                      placement="bottom"
                      // arrow={false}
                      content={profileDetails}
                      // showArrow={false}
                      className={
                        "cursor-pointer text-[11px] mr-2 flex items-center hover:text-[#e74c3c]"
                      }
                      overlayClassName="profileMenu"
                      open={popoverOpen}
                      onOpenChange={handlePopoverChange}
                    >
                      {verifiedUserData &&
                      verifiedUserData.firstName !== undefined ? (
                        <div className="profile-avatar mt-1 mr-1">
                          <p className="absolute package-label text-[white] font-semibold top-[-20px] left-[10px]">
                            {userNameAvatar !== undefined ? userNameAvatar : ""}
                          </p>
                        </div>
                      ) : (
                        ""
                      )}

                      {/* <h1
                      style={{
                        fontFamily: "Poppins",
                        fontWeight:
                          verifiedUserData &&
                          verifiedUserData.firstName !== undefined
                            ? 600
                            : "",
                        marginTop:
                          verifiedUserData &&
                          verifiedUserData.firstName !== undefined
                            ? "3px"
                            : "",
                      }}
                    >
                      {verifiedUserData &&
                      verifiedUserData.firstName !== undefined
                        ? verifiedUserData.firstName
                        : "Login"}
                    </h1> */}
                    </Popover>
                  ) : (
                    <div className="flex cursor-pointer text-[11px] mr-2 flex items-center hover:text-[#e74c3c]">
                      <UserOutlined className="icon mr-1 mt-[1.5px]" />
                      <h1
                        style={{
                          fontFamily: "Poppins",
                          fontWeight:
                            verifiedUserData &&
                            verifiedUserData.firstName !== undefined
                              ? 600
                              : "",
                          marginTop:
                            verifiedUserData &&
                            verifiedUserData.firstName !== undefined
                              ? "3px"
                              : "",
                        }}
                        onClick={() => {
                          setLoginModal(true);
                          setCustomerMobile("");
                          setPassword("");
                        }}
                      >
                        {verifiedUserData &&
                        verifiedUserData.firstName !== undefined
                          ? verifiedUserData.firstName
                          : "Login"}
                      </h1>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
          {/* )} */}
          <Row
            className={
              hideTop
                ? `${
                    media == "sm" || media == "xs"
                      ? "flex flex-col justify-center pl-4 pr-4 mt-[-60px]"
                      : media == "md"
                      ? "flex flex-col justify-center pl-[60px] pr-[6px] mt-[-60px]"
                      : media == "md" &&
                        windowDimensions.width > 750 &&
                        windowDimensions.width < 900
                      ? "flex flex-col justify-center pl-[60px] pr-[6px] mt-[-70px]"
                      : media == "lg"
                      ? "flex flex-col justify-center pl-[7.5%] pr-[7.5%] mt-[-60px]"
                      : media == "xl"
                      ? "flex justify-between pl-[5.5%] pr-[5.5%] mt-[-60px]"
                      : media == "xxl" &&
                        windowDimensions.width > 1601 &&
                        windowDimensions.width <= 1690
                      ? "flex justify-between pl-[10%] pr-[10%] mt-[-60px]"
                      : media == "xxl" && windowDimensions.width > 1690
                      ? "flex justify-between pl-[10%] pr-[10%] mt-[-60px]"
                      : "flex justify-between pl-[2.6%] pr-[2.6%] mt-[-60px]"
                  }`
                : `${
                    media == "sm" || media == "xs"
                      ? "flex flex-col justify-center pl-3 pr-3 mt-[-20px]"
                      : media == "md" &&
                        windowDimensions.width > 750 &&
                        windowDimensions.width < 900 &&
                        hideTop === false
                      ? "flex flex-col justify-center pl-[60px] pr-[60px] mt-[-30px]"
                      : media == "md"
                      ? "flex flex-col justify-center pl-[60px] pr-[60px] mt-[-20px]"
                      : media == "lg"
                      ? "flex flex-col justify-center pl-[7.5%] pr-[7.5%] mt-[-20px]"
                      : media == "xl"
                      ? "flex justify-between pl-[5.5%] pr-[5.5%] mt-[-20px]"
                      : media == "xxl" &&
                        windowDimensions.width > 1601 &&
                        windowDimensions.width <= 1690
                      ? "flex justify-between pl-[10%] pr-[10%] mt-[-20px]"
                      : media == "xxl" && windowDimensions.width > 1690
                      ? "flex justify-between pl-[10%] pr-[10%] mt-[-20px]"
                      : "flex justify-between pl-[2.6%] pr-[2.6%] mt-[-20px]"
                  }`
            }
          >
            <Col md={24} lg={24} xl={14} xxl={14} sm={24} xs={24}>
              <Row
                className={
                  hideTop === false &&
                  media === "md" &&
                  windowDimensions.width > 850 &&
                  windowDimensions.width < 900
                    ? "flex flex-row justify-center  mt-[10px]"
                    : media == "md" || media == "lg"
                    ? "flex flex-row justify-center"
                    : media == "sm" && hideTop === true
                    ? "flex flex-row justify-center mt-5"
                    : media == "sm"
                    ? "flex flex-row justify-center mt-2"
                    : media == "xs"
                    ? "flex flex-row justify-center mt-2"
                    : "flex flex-row"
                }
              >
                <div
                  className={
                    hideTop === true && media == "sm"
                      ? "layout-header-image mt-[15px]"
                      : hideTop === false && media == "sm"
                      ? "layout-header-image mt-[25px]"
                      : hideTop === true && media == "xs"
                      ? "layout-header-image mt-2"
                      : hideTop === false && media == "xs"
                      ? "layout-header-image mt-5"
                      : "layout-header-image mt-9"
                  }
                  onClick={() => {
                    history.push("/");
                  }}
                >
                  <Image src={Logo1} preview={false} width={110} />
                </div>

                <div
                  className={
                    hideTop === false &&
                    windowDimensions.width > 600 &&
                    windowDimensions.width < 690
                      ? "layout-mobile-header-menu mt-[-50px] ml-2"
                      : hideTop === true &&
                        windowDimensions.width > 600 &&
                        windowDimensions.width < 690
                      ? "layout-mobile-header-menu mt-[-50px] ml-2"
                      : hideTop === true && media === "sm"
                      ? "layout-header-menu mt-[-10px]"
                      : hideTop === false && media === "sm"
                      ? "layout-header-menu mt-[4px]"
                      : hideTop === true && media === "xs"
                      ? "layout-mobile-header-menu mt-[-10px]"
                      : hideTop === false && media === "xs"
                      ? "layout-mobile-header-menu mt-[-30px]"
                      : hideTop === false &&
                        media === "md" &&
                        windowDimensions.width > 794 &&
                        windowDimensions.width < 846
                      ? "layout-mobile-header-menu mt-[14px] ml-2"
                      : hideTop === false &&
                        media === "md" &&
                        windowDimensions.width >= 846 &&
                        windowDimensions.width < 900
                      ? "layout-mobile-header-menu mt-[14px] ml-2"
                      : hideTop === true &&
                        media === "md" &&
                        windowDimensions.width > 770 &&
                        windowDimensions.width < 900
                      ? "layout-mobile-header-menu mt-[10px]"
                      : (pageRoute === "/faq" || pageRoute === "/contact-us") &&
                        media === "xl"
                      ? "layout-header-menu mt-3 ml-3"
                      : "layout-header-menu mt-3 ml-5"
                  }
                >
                  {items.map((data, index) => {
                    return (
                      <div
                        key={index}
                        className={
                          // selectedMenuRoute === data.path ||
                          // data.path === pageRoute ||
                          // data.key == selectedMenu
                          //   ? "pr-2 pl-2 bg-[lightgray] hover:text-[#eb3e43] cursor-pointer"
                          media == "lg"
                            ? "pr-2 pl-2 hover:text-[#eb3e43] cursor-pointer"
                            : "pr-2 pl-2 hover:text-[#eb3e43] cursor-pointer"
                        }
                        onClick={() => {
                          // setSelectedMenu(data.key);
                          setSelectedMenuRoute(data.path);
                        }}
                      >
                        <h1
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            textTransform: "uppercase",
                          }}
                          className={
                            media === "xs"
                              ? "font-poppins layout-mobile-header-menu-label font-semibold"
                              : "font-poppins layout-header-menu-label font-semibold"
                          }
                        >
                          {/* <Popover
                            trigger={"hover"}
                            placement="bottom"
                            content={menuBased}
                            className="rounded-md"
                            overlayStyle={{
                              marginTop: "-20px",
                            }}
                          > */}
                          <div
                            className={
                              data.key == "packages" || data.key == "cabs"
                                ? "mt-3 cursor-pointer hover:text-[#eb3e43] text-[#636262]"
                                : "mt-[-15px] cursor-pointer hover:text-[#eb3e43] text-[#636262]"
                            }
                          >
                            {/* <p
                                className={
                                  data.key == "packages" && media !== "xs"
                                    ? "text-[20px] mt-[30px] pl-[10px]"
                                    : data.key == "cabs" && media !== "xs"
                                    ? "text-[20px] mt-[30px] text-center"
                                    : data.key == "activities" && media !== "xs"
                                    ? "text-[20px] mt-[45px] text-center"
                                    : data.key == "activities" && media === "xs"
                                    ? "text-[20px] mt-[25px] text-center"
                                    : "text-[20px] text-center"
                                }
                              >
                                {data.icon}
                              </p> */}
                            <h1
                              className={
                                (data.key == "packages" ||
                                  data.key == "cabs" ||
                                  data.key == "activities") &&
                                media !== "xs"
                                  ? "mt-[-20px] text-[12px] capitalize"
                                  : (data.key == "packages" ||
                                      data.key == "cabs" ||
                                      data.key == "activities") &&
                                    media == "xs"
                                  ? "mt-[-20px] text-[12px] capitalize"
                                  : "mt-[-40px] text-[12px] capitalize"
                              }
                            >
                              {data.label}
                            </h1>
                          </div>
                          {/* </Popover> */}
                        </h1>
                      </div>
                    );
                  })}
                </div>
              </Row>
            </Col>
            <Col
              md={24}
              lg={24}
              xl={10}
              xxl={10}
              sm={24}
              xs={24}
              className={
                windowDimensions.width >= 1200 && windowDimensions.width <= 1300
                  ? "pt-[40px] pl-[30px]"
                  : "xl:pt-[40px] xxl:pt-[40px] xl:pl-[30px] xxl:pl-[30px]"
              }
            >
              <Row
                className={
                  hideTop === true && media == "sm"
                    ? "flex flex-row justify-center mt-1"
                    : hideTop === false && media == "sm"
                    ? "flex flex-row justify-center mt-7"
                    : hideTop === true && media == "xs"
                    ? "flex flex-row justify-center mt-7"
                    : hideTop === false && media == "xs"
                    ? "flex flex-row justify-center mt-7"
                    : media == "md" || media == "lg"
                    ? "mt-[-4px] flex justify-center"
                    : media == "xxl"
                    ? "flex justify-end"
                    : "flex justify-end"
                }
              >
                <div className={"mt-[-8px] w-[75%]"} ref={destinationSearchRef}>
                  <Input
                    // variant='borderless'
                    size={media == "sm" || media == "xs" ? "small" : "large"}
                    placeholder="Enter Your Dream Destination!"
                    style={{
                      border: "0.5px solid lightgray",
                      padding:
                        media == "sm" || media == "xs"
                          ? "6px 10px"
                          : media == "md"
                          ? "6px 10px"
                          : "6px 12px",
                      // width: media == "sm" || media == "xs" ? "" : "w-[75%]",
                      borderRadius: "22px",
                      fontSize:
                        media == "sm" || media == "xs" ? "14px" : "17px",
                    }}
                    // onClick={() => setSearchDestinationSelected(true)}
                    className="border input-label rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                    prefix={
                      <SearchOutlined
                        className={
                          media == "sm" || media == "xs"
                            ? "text-[14px] mr-2"
                            : "text-[20px] mr-2"
                        }
                      />
                    }
                    suffix={
                      valueSelected !== "" ? (
                        <CloseCircleOutlined
                          onClick={() => {
                            setValueSelected("");
                            setQuery("");
                            setDestinationSelected(true);
                            setTimeout(() => {
                              setDestinationSelected(false);
                            }, 1500);
                            setSearchArrays([]);
                            dispatch(
                              loadPackagesList(
                                "?sortFilter=newest-first" +
                                  "&durationDays=" +
                                  0 +
                                  "-" +
                                  2
                              )
                            );
                          }}
                        />
                      ) : (
                        ""
                      )
                    }
                    name="query"
                    value={query}
                    onChange={handleChange}
                  />
                  <div className="w-[100%] relative mt-[-10px]">
                    {searchDestinationSelected === false ? (
                      ""
                    ) : (
                      <div
                        style={{
                          zIndex: 1000,
                        }}
                        className={
                          query !== "" &&
                          searchArrays.length > 0 &&
                          destinationSelected
                            ? ""
                            : query !== "" && searchArrays.length > 0
                            ? "destination-modal-layout absolute w-[100%] bg-white rounded-2xl shadow-lg z-10"
                            : query !== "" && searchArrays.length == 0
                            ? "packages-empty-modal-layout absolute w-[100%] bg-white rounded-2xl shadow-lg z-10"
                            : query !== ""
                            ? "destination-modal-layout absolute w-[100%] bg-white rounded-2xl shadow-lg z-10"
                            : ""
                        }
                      >
                        {/* {query !== "" ? (
                          <div className="border border-b-1 border-x-0 border-t-0 flex flex-row pl-6 text-start">
                            <h1
                              style={{
                                marginTop: "19px",
                                marginRight: "25px",
                              }}
                            >
                              <FaLocationDot className="text-[20px]" />
                            </h1>
                            <h1
                              style={{
                                fontFamily: "Poppins",
                              }}
                              className="mt-[-2px] text-[16px] font-normal"
                            >
                              Top Trending Destinations
                            </h1>
                          </div>
                        ) : (
                          ""
                        )} */}

                        {searchArrays !== undefined &&
                        searchArrays.length > 0 ? (
                          searchArrays.map((suggestion, index) => {
                            const imageUrl =
                              suggestion &&
                              suggestion.thumbnailsImages !== undefined &&
                              suggestion.thumbnailsImages.length > 0
                                ? suggestion.thumbnailsImages[0].imageUrl
                                : suggestion &&
                                  suggestion.imageUrl !== undefined
                                ? suggestion.imageUrl
                                : "";
                            const packageDataFromApi = {
                              hotels: suggestion.packageIncludes
                                ? suggestion.packageIncludes.hotels
                                : false,
                              meals: suggestion.packageIncludes
                                ? suggestion.packageIncludes.meals
                                : false,
                              transport: suggestion.packageIncludes
                                ? suggestion.packageIncludes.transport
                                : false,
                              sightSeeing: suggestion.packageIncludes
                                ? suggestion.packageIncludes.sightSeeing
                                : false,
                              packageName: suggestion.packageName,
                              _id: suggestion._id,
                              imageUrl:
                                suggestion.thumbnailsImages &&
                                suggestion.thumbnailsImages.length > 0
                                  ? suggestion.thumbnailsImages[0].imageUrl
                                  : "",
                            };

                            const destinationCountry = {
                              destinationId: suggestion._id,
                              lowestPrice: "",
                              activities: suggestion.noOfActivities,
                              packageName: suggestion.destinationName,
                              imageUrl: suggestion.imageUrl
                                ? suggestion.imageUrl
                                : "",
                            };
                            const stateActivitiesData = {
                              destinationId:
                                suggestion &&
                                suggestion.countryData !== undefined
                                  ? suggestion.countryData._id
                                  : "",
                              lowestPrice: "",
                              activities:
                                suggestion && suggestion.stateData !== undefined
                                  ? suggestion.stateData.noOfActivities
                                  : "",
                              packageName:
                                suggestion && suggestion.stateData !== undefined
                                  ? suggestion.stateData.destinationName
                                  : "",
                              imageUrl:
                                suggestion &&
                                suggestion.stateData !== undefined &&
                                suggestion.stateData.images &&
                                suggestion.stateData.images.length > 0
                                  ? suggestion.stateData.images[0].imageUrl
                                  : "",
                            };

                            const destinationCity = {
                              destinationId:
                                suggestion && suggestion.stateData !== undefined
                                  ? suggestion.stateData._id
                                  : "",
                              cityId: suggestion._id,
                              lowestPrice: "",
                              activityName: suggestion.destinationName,
                              noOfActivities: suggestion.noOfActivities,
                              activityState:
                                suggestion && suggestion.stateData !== undefined
                                  ? suggestion.stateData.destinationName
                                  : "",
                              imageUrl:
                                suggestion.imageUrl !== undefined
                                  ? suggestion.imageUrl
                                  : "",
                            };
                            const destinationArea = {
                              activityName: suggestion.destinationName,
                              imageUrl: suggestion.imageUrl
                                ? suggestion.imageUrl
                                : "",
                              // activityCity: "Kochi",
                              // activityState: "Kerala",
                              destinationId: suggestion._id,
                              cityId: suggestion.cityData
                                ? suggestion.cityData._id
                                : "",
                              areaId: suggestion._id,
                              lowestPrice: "",
                              // activityName: suggestion.cityName,
                              noOfActivities: suggestion.noOfActivities,
                              activityCity:
                                suggestion && suggestion.cityData
                                  ? suggestion.cityData.destinationName
                                  : "",
                              activityState:
                                stateActivitiesData && stateActivitiesData
                                  ? stateActivitiesData.packageName
                                  : "",
                            };

                            return (
                              <div
                                style={{
                                  fontFamily: "Poppins",
                                  height:
                                    suggestion &&
                                    (suggestion.categoryName !== undefined ||
                                      suggestion.packageCategoryName !==
                                        undefined)
                                      ? "55px"
                                      : "",
                                }}
                                key={index}
                                onClick={() => {
                                  handleClick(suggestion);
                                  setSearchDestinationSelected(false);
                                  setDestinationSelected(true);
                                  setTimeout(() => {
                                    setDestinationSelected(false);
                                  }, 1500);
                                  if (
                                    suggestion &&
                                    suggestion.packageName !== undefined
                                  ) {
                                    history.push({
                                      pathname: `/package-details/${suggestion.packageName}`,
                                      state: packageDataFromApi,
                                    });
                                    setQuery(suggestion.packageName);
                                  }
                                  if (
                                    suggestion &&
                                    suggestion.packageCategoryName !== undefined
                                  ) {
                                    history.push({
                                      pathname: `/packages/${suggestion.packageCategoryName}`,
                                      state: suggestion,
                                    });
                                    setQuery(suggestion.packageCategoryName);
                                  }
                                  if (
                                    suggestion &&
                                    suggestion.destinationName !== undefined &&
                                    suggestion.type !== undefined &&
                                    suggestion.type === "Country"
                                  ) {
                                    history.push({
                                      pathname: `/destinations`,
                                    });
                                    setQuery(suggestion.destinationName);
                                  }
                                  if (
                                    suggestion &&
                                    suggestion.destinationName !== undefined &&
                                    suggestion.type !== undefined &&
                                    suggestion.type === "State"
                                  ) {
                                    history.push({
                                      pathname: `/destinations/destination-in-${destinationCountry.packageName}`,
                                      state: destinationCountry,
                                    });
                                    setQuery(suggestion.destinationName);
                                  }
                                  if (
                                    suggestion &&
                                    suggestion.destinationName !== undefined &&
                                    suggestion.type !== undefined &&
                                    suggestion.type === "City"
                                  ) {
                                    window.open(
                                      `/destinations/destination-in-${
                                        stateActivitiesData.packageName
                                      }/${
                                        destinationCity.activityName
                                      }?activities=${encodeURIComponent(
                                        JSON.stringify(stateActivitiesData)
                                      )}&cityData=${encodeURIComponent(
                                        JSON.stringify(destinationCity)
                                      )}`,
                                      "_blank"
                                    );
                                    // history.push({
                                    //   pathname: `/destinations`,
                                    //   // pathname: `/destinations/${suggestion.destinationName}`,
                                    //   state: suggestion,
                                    // });
                                    setQuery(suggestion.destinationName);
                                  }
                                  if (
                                    suggestion &&
                                    suggestion.destinationName !== undefined &&
                                    suggestion.type !== undefined &&
                                    suggestion.type === "Area"
                                  ) {
                                    window.open(
                                      `/destinations/destination-in-${
                                        stateActivitiesData.packageName
                                      }/${
                                        destinationArea.activityCity
                                      }/Places to Visit in ${
                                        destinationArea.activityCity
                                      }/${
                                        destinationArea.activityName
                                      }?activities=${encodeURIComponent(
                                        JSON.stringify(stateActivitiesData)
                                      )}&cityList=${encodeURIComponent(
                                        JSON.stringify(destinationCity)
                                      )}&area=${encodeURIComponent(
                                        JSON.stringify(destinationArea)
                                      )}`,
                                      "_blank"
                                    );
                                    // history.push({
                                    //   pathname: `/destinations`,
                                    //   // pathname: `/destinations/${suggestion.destinationName}`,
                                    //   state: suggestion,
                                    // });
                                    setQuery(suggestion.destinationName);
                                  }
                                  // if (pageRoute == "/packages") {
                                  //   dispatch(
                                  //     loadPackagesList(
                                  //       "?destinationIds=" + suggestion._id
                                  //     )
                                  //   );
                                  // } else {
                                  //   history.push({
                                  //     pathname: `/packages/${suggestion.destinationName}`,
                                  //     state: suggestion,
                                  //   });
                                  // }
                                }}
                                className={
                                  "pl-4 text-start border border-black-400 border-b-1 border-x-0 hover:bg-[#fff3f3] border-t-0 cursor-pointer"
                                }
                              >
                                {suggestion &&
                                suggestion.packageName !== undefined ? (
                                  <p className="text-[13px] mt-[-10px] mb-[-25px] font-semibold text-[#eb3e43]">
                                    {suggestion &&
                                    suggestion.packageName !== undefined
                                      ? "Packages"
                                      : ""}
                                  </p>
                                ) : (
                                  ""
                                )}
                                <div
                                  className={
                                    media === "xl"
                                      ? "flex"
                                      : suggestion &&
                                        suggestion.destinationName !== undefined
                                      ? "flex justify-between"
                                      : "mt-[-15px] flex justify-between"
                                  }
                                >
                                  <div
                                    className={
                                      suggestion &&
                                      (suggestion.categoryName !== undefined ||
                                        suggestion.packageCategoryName !==
                                          undefined)
                                        ? "flex mt-1"
                                        : "flex"
                                    }
                                  >
                                    {suggestion &&
                                    (suggestion.categoryName !== undefined ||
                                      suggestion.packageCategoryName !==
                                        undefined) ? (
                                      <Category className="xl:mt-[8px] border mt-[20px] text-[#eb3e43] border-lightgray-1 rounded-md" />
                                    ) : (
                                      <Image
                                        // loading="lazy"
                                        src={imageUrl}
                                        preview={false}
                                        width={40}
                                        height={40}
                                        className="border border-lightgray-1 mt-[8px] rounded-md"
                                      />
                                    )}
                                    {media === "xl" ? (
                                      ""
                                    ) : (
                                      <p className="hover:text-[#eb3e43] mt-[-2px] text-[14px] font-normal ml-4">
                                        {" "}
                                        {suggestion &&
                                        suggestion.packageName !== undefined
                                          ? suggestion.packageName
                                          : suggestion &&
                                            suggestion.destinationName !==
                                              undefined
                                          ? suggestion.destinationName
                                          : suggestion.categoryName
                                          ? suggestion.categoryName
                                          : suggestion.packageCategoryName !==
                                            undefined
                                          ? suggestion.packageCategoryName
                                          : ""}
                                      </p>
                                    )}
                                  </div>
                                  <div>
                                    {media === "xl" ? (
                                      <p
                                        className={
                                          suggestion &&
                                          suggestion.destinationName !==
                                            undefined
                                            ? "mt-[-5px] hover:text-[#eb3e43] text-[14px] font-normal ml-4"
                                            : suggestion.categoryName !==
                                                undefined ||
                                              suggestion.packageCategoryName !==
                                                undefined
                                            ? "mt-[-5px] hover:text-[#eb3e43] text-[14px] font-normal ml-4"
                                            : "mt-[-13px] hover:text-[#eb3e43] text-[14px] font-normal ml-4"
                                        }
                                      >
                                        {" "}
                                        {suggestion &&
                                        suggestion.packageName !== undefined
                                          ? suggestion.packageName
                                          : suggestion &&
                                            suggestion.destinationName !==
                                              undefined
                                          ? suggestion.destinationName
                                          : suggestion.categoryName
                                          ? suggestion.categoryName
                                          : suggestion.packageCategoryName !==
                                            undefined
                                          ? suggestion.packageCategoryName
                                          : ""}
                                      </p>
                                    ) : (
                                      ""
                                    )}

                                    {suggestion &&
                                    suggestion.packageName !== undefined ? (
                                      <p
                                        className={
                                          media === "xl"
                                            ? "mt-[-45px] ml-4 text-[11.5px] font-semibold text-[#eb3e43]"
                                            : "text-[11.5px] mr-3 font-semibold text-[#eb3e43]"
                                        }
                                      >
                                        {suggestion &&
                                        suggestion.packageName !== undefined
                                          ? suggestion.totalDayAndNight
                                          : ""}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                {suggestion &&
                                suggestion.packageName !== undefined ? (
                                  ""
                                ) : (
                                  <div className="flex flex-row justify-between mt-[-28px] mb-[-13px]">
                                    {/* <div className="xl:mt-[-25px] flex flex-row xl:flex-col justify-between mt-[-28px] mb-[-13px]"> */}
                                    <h1 className="text-[11.5px] font-semibold text-[#eb3e43]">
                                      {suggestion &&
                                      suggestion.destinationName !==
                                        undefined &&
                                      suggestion.type === "State" &&
                                      suggestion &&
                                      suggestion.countryData !== undefined
                                        ? suggestion.countryData.destinationName
                                        : suggestion &&
                                          suggestion.destinationName !==
                                            undefined &&
                                          suggestion.type === "City" &&
                                          suggestion &&
                                          suggestion.stateData !== undefined
                                        ? suggestion.stateData.destinationName +
                                          " , " +
                                          suggestion.countryData.destinationName
                                        : suggestion &&
                                          suggestion.destinationName !==
                                            undefined &&
                                          suggestion.type === "Area" &&
                                          suggestion &&
                                          suggestion.stateData !== undefined
                                        ? suggestion.cityData.destinationName +
                                          " , " +
                                          suggestion.stateData.destinationName +
                                          " , " +
                                          suggestion.countryData.destinationName
                                        : suggestion &&
                                          suggestion.destinationName
                                        ? suggestion.destinationName
                                        : ""}
                                    </h1>
                                    <p className="text-[11.5px] pr-3 font-semibold text-[#eb3e43]">
                                      {/* <p className="xl:mt-[-25px] text-[11.5px] pr-3 font-semibold text-[#eb3e43]"> */}
                                      {suggestion.type !== undefined
                                        ? suggestion.type
                                        : ""}
                                    </p>
                                  </div>
                                )}
                              </div>
                            );
                          })
                        ) : query !== "" && searchArrays.length === 0 ? (
                          <div className="h-[60px] absolute w-[100%] z-100">
                            {/* <div className="h-[70px] absolute w-[100%] bg-white rounded-2xl shadow-lg z-10"> */}
                            <h1
                              style={{
                                fontFamily: "Poppins",
                              }}
                              className="w-[100%] flex pl-4 mt-4 text-[14px] justify-center"
                            >
                              {destinationLoading ? (
                                <Spin
                                  indicator={
                                    <LoadingOutlined
                                      style={{ fontSize: 40 }}
                                      spin
                                    />
                                  }
                                />
                              ) : (
                                "No data found.."
                              )}
                            </h1>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {/* {searchedDestinations.length > 0 ? (
                    <div className="bg-[white] shadow-lg rounded-md z-100">

                    </div>
                  ) : (
                    ""
                  )} */}

                <div
                  className={
                    media == "sm" || media == "xs"
                      ? "w-[100px] hover bg-[#eb3e43] hover:bg-[red] h-[30px] text-[14px] ml-3 mt-2"
                      : "w-[20%] hover bg-[#eb3e43] hover:bg-[red] h-[40px] text-[16px] ml-2 mt-1"
                  }
                  style={{
                    borderRadius: "22px",
                    fontFamily: "Poppins",
                    fontWweight: 800,
                    color: "white",
                    cursor: "pointer",
                    marginTop: "3px",
                    zIndex: 20,
                  }}
                  onClick={() => {
                    setDestinationSelected(true);
                    setTimeout(() => {
                      setDestinationSelected(false);
                    }, 1500);
                    if (pageRoute == "/packages") {
                      dispatch(
                        loadPackagesList(
                          "?destinationIds=" + selectedDestination._id
                        )
                      );
                    }
                  }}
                >
                  <h1
                    className={
                      media == "sm" || media == "xs"
                        ? "mt-[-16px]"
                        : "mt-[-11px]"
                    }
                  >
                    {/* {destinationSelected === true ? (
                      <p className="flex input-label">
                        <Spin /> Loading...
                      </p>
                    ) : ( */}
                    Search
                    {/* )} */}
                  </h1>
                </div>
              </Row>
            </Col>
          </Row>
        </Header>
        <Content className="content-card w-[100%] scroll-container">
          <div
            style={{
              textAlign: "start",
              marginTop:
                media == "sm"
                  ? "200px"
                  : media == "xs"
                  ? "270px"
                  : media == "md" &&
                    windowDimensions.width > 770 &&
                    windowDimensions.width < 900 &&
                    hideTop === false
                  ? "185px"
                  : media == "md"
                  ? "130px"
                  : "65px",
            }}
          >
            {props.children}
          </div>
          <div className="mt-[115px] ml-[-6px] w-[101%]" id="footer">
            {/* <Image
              src={sectionFooter}
              preview={false}
              width={"100%"}
              height={"133px"}
              style={{
                marginTop: "5px",
                marginBottom: "-6px",
              }}
            /> */}
            {/* <div className="w-full footer-border"></div> */}
            <div
              className={`w-full flex ${
                media === "sm" || media === "xs" ? "flex-col" : "flex-row"
              } p-6 bg-[#111]`}
            >
              {/* Left Navigation Tabs */}
              <div
                className={`mb-1 ${
                  media === "sm" || media === "xs" ? "w-full" : "w-1/4"
                }`}
              >
                {footerList.map((data, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setFooterTabs(data.label);
                      history.push(data.path);
                    }}
                    className={`cursor-pointer py-2 pl-2 uppercase text-white text-[13px] font-medium transition-all ${
                      footerTabs === data.label
                        ? "bg-[#eb3a3e] border-l-[6px] border-r-[6px] border-black"
                        : "border-b border-gray-600 hover:text-[#eb3a3e]"
                    }`}
                    style={{ fontFamily: "Poppins" }}
                  >
                    {data.label}
                  </div>
                ))}
              </div>

              {/* Right Content */}
              <div
                className={`${
                  media === "sm" || media === "xs"
                    ? "w-full mt-4"
                    : "w-3/4 pl-8"
                }`}
              >
                <h1
                  className="text-white font-semibold text-lg mb-4"
                  style={{ fontFamily: "Poppins" }}
                >
                  Make your travel easy with a wide range of products and
                  services.
                </h1>
                <Row gutter={[16, 16]}>
                  {travelModeLinks.map((data, index) => (
                    <Col
                      key={index}
                      xs={24}
                      sm={12}
                      md={6}
                      className="cursor-pointer text-white text-sm hover:text-[#eb3a3e] transition"
                      style={{ fontFamily: "Poppins" }}
                      onClick={() => history.push(data.path)}
                    >
                      {data.label}
                    </Col>
                  ))}
                </Row>

                {/* QR Section */}
                {/* <div className="mt-6 pr-5 flex flex-col md:flex-row justify-end">
                  <div className="bg-[#1f1f1f] pt-2 pb-2 pr-3 pl-3 rounded-lg shadow-md text-center w-fit">
                    <h1
                      className="text-white font-semibold text-sm mb-2 uppercase"
                      style={{ fontFamily: "Poppins" }}
                    >
                      Scan QR Code
                    </h1>
                    <div className="w-full border-t-2 border-[#eb3a3e] mb-3"></div>
                    <Image
                      src={Qrcode}
                      preview={false}
                      height={100}
                      width={100}
                      className="mx-auto cursor-pointer border border-gray-500 rounded-md"
                    />
                  </div>
                </div> */}
              </div>
            </div>
            <footer
              style={{
                fontFamily: "Poppins",
              }}
              className="bg-[#0e0e0e] text-gray-300 text-center"
            >
              {/* <div className="bg-red-600 h-[2px]"></div>  */}
              <div className="py-3 text-[13px]">
                Copyright © {moment().format("YYYY")}{" "}
                <a href="/" className="text-[#eb3e43] hover:underline">
                  Plan Mi Trip.
                </a>{" "}
                All rights reserved
              </div>
            </footer>
          </div>
        </Content>
        {/* Enquire modal */}
        <Modal
          open={loginModal}
          // title="Want to Go For A Memorable Holiday?"
          maskClosable={false}
          onOk={() => loginDetailsApi()}
          closable
          onCancel={() => setLoginModal(false)}
          okButtonProps={{
            disabled: loginBtnDisabled ? true : false,
          }}
          footer={null}
          className="package-fonts mt-[40px]"
          closeIcon
          width={400}
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24} className="">
            <Row className="">
              <Col
                md={24}
                sm={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-[-6px] package-fonts text-[18px] font-semibold"
              >
                Login
              </Col>
            </Row>
            <Row className="w-[113.5%] mt-2 ml-[-24px] border border-b-1 border-x-0 border-t-0"></Row>
            <Row className="">
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-2"
              >
                <Typography className="package-fonts text-[14px] mb-[4px]">
                  Mobile
                </Typography>
                <Input
                  name="customerMobile"
                  value={customerMobile}
                  id="main-enquire-input"
                  onChange={validationEnquireChange}
                  style={{
                    height: "40px",
                    fontFamily: "Poppins",
                  }}
                  maxLength={10}
                  placeholder="Enter your mobile"
                  className="package-fonts text-[14px]"
                  suffix={<FaMobile className="text-[14px] text-[#818181]" />}
                />
                <div id="error-enquire-panel">
                  {customerMobileValidations == true ? (
                    <p className="input-label text-[11px] text-start text-[#ff0000]">
                      The mobile field is not valid
                    </p>
                  ) : (
                    loginValidations === true &&
                    customerMobile === "" && (
                      <p
                        style={{
                          display: "inline-block",
                        }}
                        className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                      >
                        {loginValidations === true && customerMobile === ""
                          ? "The mobile field is required"
                          : ""}
                      </p>
                    )
                  )}
                </div>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-2"
              >
                <Typography className="package-fonts text-[14px] mb-[4px]">
                  Password
                </Typography>
                <Input.Password
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    height: "40px",
                    fontFamily: "Poppins",
                  }}
                  maxLength={10}
                  placeholder="Enter your password"
                  className="package-fonts text-[14px]"
                  suffix={<FaKey className="text-[14px] text-[#818181]" />}
                />
                {loginValidations === true && password === "" && (
                  <p
                    style={{
                      display: "inline-block",
                    }}
                    className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                  >
                    {loginValidations === true && password === ""
                      ? "The password field is required"
                      : ""}
                  </p>
                )}
              </Col>
            </Row>
            <Row className="w-[113.5%] mt-[30px] ml-[-24px] border border-b-1 border-x-0 border-t-0"></Row>
            <Row className="mt-4">
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="flex justify-end"
              >
                <div
                  style={{
                    borderRadius: "4px",
                    pointerEvents: loginBtnDisabled ? "none" : "",
                    opacity: loginBtnDisabled ? 1 : "",
                  }}
                  onClick={() => {
                    setLoginModal(false);
                  }}
                  className="mr-3 hover:bg-[lightgray] cursor-pointer pl-4 pr-4 pt-1 pb-1 package-fonts border border-1 text-center text-[14px] bg-[white]"
                >
                  <h1 className="">Cancel</h1>
                </div>
                <div
                  style={{
                    borderRadius: "4px",
                    pointerEvents: loginBtnDisabled ? "none" : "",
                    opacity: loginBtnDisabled ? 1 : "",
                  }}
                  onClick={() => {
                    loginDetailsApi();
                  }}
                  className="cursor-pointer hover:bg-[red] pl-4 pr-4 pt-1 pb-1 package-fonts text-center text-[14px] bg-[#eb3e43] text-[white]"
                >
                  {/* {loginBtnDisabled ? (
                    <p className="package-fonts">
                      <Spin className="text-[white]" />
                    </p>
                  ) : ( */}
                  <h1 className="">Login</h1>
                  {/* )} */}
                </div>
              </Col>
            </Row>
          </Col>
        </Modal>
        <Modal
          open={chatModal}
          title=""
          maskClosable={false}
          onClose={() => setChatModal(false)}
          // onCancel={() => setChatModal(false)}
          // onCancel={false}
          closable
          footer={null}
          closeIcon={
            <CloseOutlined
              onClick={() => setChatModal(false)}
              className="text-[#ffffff]"
            />
          }
          width={500}
        >
          {/* <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          /> */}
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <div className="w-[110.6%] ml-[-24px] mt-[-20px] global-modal-img rounded-md">
              <Row>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={12}
                  sm={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="p-3"
                >
                  <h2 className="text-[#ffffff]">
                    Don't miss out on our exclusive deals & insider only offers!
                  </h2>
                  <div className="text-[#ffffff] mt-2">
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      5 years of Experience in India
                    </div>
                    {/* <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Packages across 50 + Countries
                    </div> */}
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Best Travel Partner of India
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                {" "}
                <Col
                  md={24}
                  sm={24}
                  xs={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  className={
                    media == "md" || media == "sm" || media == "xs"
                      ? "pl-0 mt-[20px]"
                      : "pl-0 mt-4"
                  }
                >
                  {/* <Image src={ContactUsLogo} preview={false} width={400} height={350} /> */}

                  <Row className="p-4 mb-[-8px] bg-[#ffffff]">
                    {/* <Col
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                xs={24}
                sm={24}
                className="pr-3 mb-1"
              >
                <Typography
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="input-label mb-2 text-[18px] font-extrabold"
                >
                  Send Message
                </Typography>
              </Col> */}
                    <Col
                      md={24}
                      lg={12}
                      xl={12}
                      xxl={12}
                      xs={24}
                      sm={24}
                      className="pr-3 mb-1"
                      style={{
                        fontFamily: "Poppins",
                      }}
                    >
                      <Typography className="mb-2 text-[12px] input-label">
                        Full Name
                      </Typography>
                      <Input
                        name="prefixValue"
                        className={"rounded-md h-[40px] input-label"}
                        placeholder="Enter name"
                      />
                    </Col>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={12}
                      xl={12}
                      xxl={12}
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="pr-3 mb-1"
                    >
                      <Typography className="mb-2 text-[12px] input-label">
                        Email
                      </Typography>
                      <Input
                        name="mail"
                        className={"rounded-md h-[40px] input-label"}
                        placeholder="Enter mail"
                      />
                    </Col>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={12}
                      xl={12}
                      xxl={12}
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="pr-3 mb-1 mt-2"
                    >
                      <Typography className="mb-2 text-[12px] input-label">
                        Mobile
                      </Typography>
                      <Input
                        name="mail"
                        className={"rounded-md h-[40px] input-label"}
                        placeholder="Enter mobile no"
                      />
                    </Col>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={12}
                      xl={12}
                      xxl={12}
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="pr-3 mb-1 mt-2"
                    >
                      <Typography className="mb-2 text-[12px] input-label">
                        Message
                      </Typography>
                      <Input.TextArea
                        name="prefixValue"
                        className={"rounded-md input-label h-[60px]"}
                        placeholder="Enter message"
                      />
                    </Col>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="pr-3 mb-2 mt-5"
                    >
                      <div
                        className={
                          media == "sm" || media == "xs"
                            ? "w-[100%] hover bg-[#eb3e43] text-center hover:bg-[red] h-[30px] text-[14px] mt-1"
                            : "w-[100%] hover bg-[#eb3e43] text-center hover:bg-[red] h-[40px] text-[16px] mt-1"
                        }
                        style={{
                          borderRadius: "4px",
                          fontFamily: "Poppins",
                          fontWweight: 800,
                          color: "white",
                          cursor: "pointer",
                          marginTop: "3px",
                          padding: "8px 10px",
                          zIndex: 20,
                        }}
                      >
                        Send Message
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Col>

          {/* <Collapse
            items={paymentFaqList}
            expandIcon={<DownCircleOutlined />}
            expandIconPosition="right"
            className="font-semibold"
            bordered
            style={{
              fontFamily: "Poppins",
            }}
          /> */}
        </Modal>
        {scrollTop ? (
          <div
            onClick={
              () => document.getElementById("scrollTop").scrollIntoView()
              // setScrollTop(false);
            }
            class="cursor-pointer fixed bottom-[112px] right-[20px] bg-[#eb3a3e] text-white px-4 py-3 rounded-full shadow-lg"
          >
            <Tooltip
              placement="top"
              title="Scroll Top"
              className="text-[12px] font-label"
            >
              <UpCircleFilled className="text-[16px]" />
            </Tooltip>
          </div>
        ) : (
          // <FloatButton
          //   className="w-[50px] h-[50px]"
          //   type="primary"
          //   style={{
          //     margin: "92px -7px",
          //   }}
          //   onClick={
          //     () => document.getElementById("scrollTop").scrollIntoView()
          //     // setScrollTop(false);
          //   }
          //   icon={<UpCircleFilled />}
          // />
          ""
        )}

        <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-7px",
          }}
          onClick={() => setChatModal(!chatModal)}
          icon={<CommentOutlined />}
        />
      </Layout>
      <Toaster
        position="top-center"
        containerStyle={{
          fontFamily: "Poppins",
          fontSize: "13px",
          fontWeight: 600,
        }}
        toastOptions={{
          duration: 3000,
        }}
        reverseOrder={false}
      />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{
          fontSize: "12px",
        }}
        // className={"flex flex-start justify-start"}
        theme="dark"
      />
    </React.Fragment>
  );
};

LayoutMain.propTypes = {
  children: PropTypes.object,
  location: PropTypes.object,
};
export default withRouter(LayoutMain);
